//Paquetes NPM de GYF. 
import { Mediator } from 'com-gyf-webcore-mediator';
import ProcessManager from '../../../Common/Managers/ProcessManager';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let _dispatch = null;
let userFeatures = [];
let userFunctions = [];

export const INITIAL_STATE_LISTADO_PRODUCTO = 'INITIAL_STATE_LISTADO_PRODUCTO';
export const GET_SCREEN_DATA_LISTADO_PRODUCTO = 'GET_SCREEN_DATA_LISTADO_PRODUCTO';
export const GET_ALL_PRODUCTS_LISTADO_PRODUCTO = 'GET_ALL_PRODUCTS_LISTADO_PRODUCTO';
export const GET_ALL_PRODUCTS_RESULT_LISTADO_PRODUCTO = 'GET_ALL_PRODUCTS_RESULT_LISTADO_PRODUCTO';
export const ROLLBACK_LISTADO_PRODUCTO = 'ROLLBACK_LISTADO_PRODUCTO';
export const FILTER_SEARCH_USER_LISTADO_PRODUCTO = 'FILTER_SEARCH_USER_LISTADO_PRODUCTO';
export const SELECT_ALL_CHECKBOX_LISTADO_PRODUCTO = 'SELECT_ALL_CHECKBOX_LISTADO_PRODUCTO';
export const CLICK_CHECKBOX_LISTADO_PRODUCTO = 'CLICK_CHECKBOX_LISTADO_PRODUCTO';
export const CHANGE_STATES_LISTADO_PRODUCTO = 'CHANGE_STATES_LISTADO_PRODUCTO';
export const CHANGE_STATES_SELECTION_LISTADO_PRODUCTO = 'CHANGE_STATES_SELECTION_LISTADO_PRODUCTO';
export const CHANGE_STATES_SELECTION_DONE_LISTADO_PRODUCTO = 'CHANGE_STATES_SELECTION_DONE_LISTADO_PRODUCTO';
export const FILTER_CHECKBOX_LISTADO_PRODUCTO = 'FILTER_CHECKBOX_LISTADO_PRODUCTO';
export const FILTER_ORDER_COLUMN_LISTADO_PRODUCTO = 'FILTER_ORDER_COLUMN_LISTADO_PRODUCTO';
export const DISABLE_BUTTON_LISTADO_PRODUCTO = 'DISABLE_BUTTON_LISTADO_PRODUCTO';
export const GENERAL_FILTER_LISTADO_PRODUCTO = 'GENERAL_FILTER_LISTADO_PRODUCTO';
export const UPDATE_MOTIVO_BLOQUEO_LISTADO_PRODUCTO = 'UPDATE_MOTIVO_BLOQUEO_LISTADO_PRODUCTO';
export const DELETE_PRODUCTOS_LISTADO_PRODUCTO = 'DELETE_PRODUCTOS_LISTADO_PRODUCTO';
export const ROUTE_TO_NUEVO_PRODUCTO_LISTADO_PRODUCTO = 'ROUTE_TO_NUEVO_PRODUCTO_LISTADO_PRODUCTO';
export const ROUTE_TO_EDITAR_PRODUCTO_LISTADO_PRODUCTO = 'ROUTE_TO_EDITAR_PRODUCTO_LISTADO_PRODUCTO';
export const FUNCTION_CODE_CREATE_LISTADO_PRODUCTO = "Alta";
export const FUNCTION_CODE_DELETE_LISTADO_PRODUCTO = "Baja";
export const FUNCTION_CODE_EXPORT_LISTADO_PRODUCTO = "Exportacion";
export const FUNCTION_CODE_EDIT_LISTADO_PRODUCTO = "Modificacion";
export const FUNCTION_CODE_QUERY_LISTADO_PRODUCTO = "Consulta";
export const SET_USER_FUNCTIONS_LISTADO_PRODUCTO = 'SET_USER_FUNCTIONS_LISTADO_PRODUCTO';
export const LISTADO_PRODUCTOS_REDIRECT_LISTADO_PRODUCTO = 'LISTADO_PRODUCTOS_REDIRECT_LISTADO_PRODUCTO';

/** 
 * Action que obtiene el estado inicial.
 * @param {any} state
 * @param {any} currentScope
 */
export function getScreenData(state, currentScope) {
    LogHelper.In(getScreenData.name, state, currentScope);

    return (dispatch) => {
        _dispatch = dispatch;

        dispatch({ type: GET_ALL_PRODUCTS_LISTADO_PRODUCTO, state });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadUserListFunctions(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/** 
 * Action que obtiene el estado inicial.
 * @param {any} state
 * @param {any} currentScope
 */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE_LISTADO_PRODUCTO });
    }
    
}

/**
 * 
 */
export function selectAllCheckbox() {
    LogHelper.In(selectAllCheckbox.name);

    return (dispatch) => {

        dispatch({
            type: SELECT_ALL_CHECKBOX_LISTADO_PRODUCTO
        });
    }
}

/**
 * 
 * @param {any} Id
 */
export function clickCheckbox(Id) {
    LogHelper.In(clickCheckbox.name, Id);

    return (dispatch) => {
        dispatch({
            type: CLICK_CHECKBOX_LISTADO_PRODUCTO,
            valueId: Id
        });
    }
}

/**
 * 
 * @param {any} id
 * @param {any} activo
 * @param {any} bloqueado
 */
export function changeStates(id, activo, bloqueado) {
    LogHelper.In(changeStates.name, id, activo, bloqueado);

    return (dispatch) => {

        dispatch({
            type: CHANGE_STATES_LISTADO_PRODUCTO,
            valueId: id,
            valueActivo: activo,
            valueBloqueado: bloqueado
        });
    }
}

/**
 * 
 * @param {any} typeButton
 */
export function changeStateWithCheckSelection(typeButton) {
    LogHelper.In(changeStateWithCheckSelection.name, typeButton);

    return (dispatch) => {

        dispatch({
            type: CHANGE_STATES_SELECTION_LISTADO_PRODUCTO,
            value: typeButton
        });
    }
}


/**
 * 
 * @param {any} id
 */
export function disableButton(id) {
    LogHelper.In(disableButton.name, id);

    return (dispatch) => {

        dispatch({
            type: DISABLE_BUTTON_LISTADO_PRODUCTO,
            valueId: id
        });
    }
}

/**
 * 
 * @param {any} indexCheck
 */
export function filterCheckbox(indexCheck) {
    LogHelper.In(filterCheckbox.name, indexCheck);

    return (dispatch) => {

        dispatch({
            type: FILTER_CHECKBOX_LISTADO_PRODUCTO,
            valueIndex: indexCheck
        });
    }
}

/**
 * 
 * @param {any} searchName
 */
export function searchUser(searchName) {
    LogHelper.In(searchUser.name, searchName);

    return (dispatch) => {

        dispatch({
            type: FILTER_SEARCH_USER_LISTADO_PRODUCTO,
            value: searchName
        });
    }
}

/**
 * 
 * @param {any} nameOfColumn
 */
export function orderColumn(nameOfColumn) {
    LogHelper.In(orderColumn.name, nameOfColumn);

    return (dispatch) => {

        dispatch({
            type: FILTER_ORDER_COLUMN_LISTADO_PRODUCTO,
            value: nameOfColumn
        });
    }
}

/**
 * 
 * @param {any} motivoBloqueo
 */
export function updateMotivoBloqueo(motivoBloqueo) {
    LogHelper.In(updateMotivoBloqueo.name, motivoBloqueo);

    return (dispatch) => {

        dispatch({
            type: UPDATE_MOTIVO_BLOQUEO_LISTADO_PRODUCTO,
            motivoBloqueo: motivoBloqueo
        });
    }
}

/**
 * 
 */
export function deleteProductos() {
    LogHelper.In(deleteProductos.name);

    return (dispatch) => {

        dispatch({
            type: DELETE_PRODUCTOS_LISTADO_PRODUCTO,
        });
    }
}

/**
 * 
 */
export function routeToNuevoProducto() {
    LogHelper.In(routeToNuevoProducto.name);

    return (dispatch) => {
        _routing(0, ROUTE_TO_NUEVO_PRODUCTO_LISTADO_PRODUCTO, dispatch);
    }
}

/**
 * 
 * @param {any} id
 * @param {any} dispatch
 */
export function routeToEditarProducto(id, dispatch) {
    LogHelper.In(routeToEditarProducto.name, id, dispatch);

    return (dispatch) => {
        _routing(id, ROUTE_TO_EDITAR_PRODUCTO_LISTADO_PRODUCTO, dispatch);
    }
}

/** ---------------------------------------- FUNCIONES AUXILIARES ---------------------------------------- **/

/**
 * Funcion encargada del ruteo.
 * @param {any} params
 * @param {any} option
 * @param {any} dispatch
 */
function _routing(params, option, dispatch) {
    LogHelper.In(_routing.name, params, option, dispatch);

    if (params) {
        params = JSON.stringify(params);
    }
    
    const redirectLocation = ProcessManager.GetNextStep("ListadoProductos", option, params) + "/" + params;

    dispatch({ type: LISTADO_PRODUCTOS_REDIRECT_LISTADO_PRODUCTO, data: redirectLocation })
}


/**
 * Carga los permisos del usuario.
 * @param {any} data
 */
function _loadUserListFunctions(data) {
    LogHelper.In(_loadUserListFunctions.name, data);

    userFeatures = JSON.parse(JSON.stringify(data)); //Todos los permisos por feature del usuario en el programa.
    userFunctions = JSON.parse(JSON.stringify(data.ADMINPRODUCTOS)); //Permisos del usuario para la feature a utilizar.

    userFunctions.Alta = userFunctions.some(f => {
        return f.Codigo_Funcion == FUNCTION_CODE_CREATE_LISTADO_PRODUCTO
    });

    userFunctions.Baja = userFunctions.some(f => {
        return f.Codigo_Funcion == FUNCTION_CODE_DELETE_LISTADO_PRODUCTO
    });

    userFunctions.Exportacion = userFunctions.some(f => {
        return f.Codigo_Funcion == FUNCTION_CODE_EXPORT_LISTADO_PRODUCTO
    });

    userFunctions.Consulta = userFunctions.some(f => {
        return f.Codigo_Funcion == FUNCTION_CODE_QUERY_LISTADO_PRODUCTO
    });
    
    _dispatch({ type: SET_USER_FUNCTIONS_LISTADO_PRODUCTO, userFeatures: userFeatures, userFunctions: userFunctions });

    if (userFunctions.Consulta) {
        loadProductos();
    }
}

/**
 * Obtiene los productos existentes de la base.
 */
function loadProductos() {
    LogHelper.In(loadProductos.name);

    LogHelper.Out(loadProductos.name, null, 'GET_PRODUCTOS', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PRODUCTOS', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
    Engine1Proxy.Execute(_loadUserListInitialStateData, null, null, "ADMINPRODUCTOS");
}

function _loadUserListInitialStateData(data) {
    LogHelper.In(_loadUserListInitialStateData.name, data);

    let loadedState = {
        "get_all_products": JSON.parse(data.GET_PRODUCTOS).Recordset0.Rows,
        "get_all_products_filter": JSON.parse(data.GET_PRODUCTOS).Recordset0.Rows,
        "checks": [],
        "checksDeleted": [],
        "deleteProducts": [],
        "search": "",
        "disableTrashButton": true,
        "activo": true,
        "bloqueado": true,
        "selectAllCheckbox": false,
        "countCheckboxToBlock": 0,
        "columnIndex": 0,
        "motivo": "",
        "column": [{ "name": "nombre", "state": false }, { "name": "login", "state": true }, { "name": "sucursal", "state": true }, { "name": "sector", "state": true }],
        "checksFilter": [{ "name": "todo", "state": true }, { "name": "activos", "state": true }, { "name": "bloqueados", "state": true }, { "name": "eliminados", "state": true }],
        'user_features': userFeatures,
        'user_functions': userFunctions,
        "current_user": ""
    }

    Mediator.SetWebStorageValue("ListadoProductos", loadedState);

    _dispatch({ type: GET_ALL_PRODUCTS_RESULT_LISTADO_PRODUCTO, data: loadedState });
}